import React from 'react';
import { Box, Button } from "@mui/material";
import video from '../assets/Ghostloop.mp4'
import MobileAppBar from "../components/MobileAppBar";
const MainSection = () => {

  window.addEventListener('scroll', reveal);
  function reveal() {
    const reveals = document.querySelectorAll('.reveal');
    for (let i = 0; i < reveals.length; i++) {
      const windowHeight = window.innerHeight;
      const elementTop = reveals[i].getBoundingClientRect().top;
      const elementVisible = 150;

      if (elementTop < windowHeight - elementVisible) {
        reveals[i].classList.add('active');
      }
    }
    return reveals;
  }
  React.useEffect(() => {
    const reveals = reveal();
    reveals[0].classList.add('active');
  });

  return (
    
    <div
      id="main-section-id"
      className="main-section-container"
      // sx={{
      //   // backgroundImage: "url(images//SWD_No_Title_Final.jpeg)",
      //   // backgroundSize: "cover",
      //   width: "100vw",
      //   minHeight: "100vh",
      //   display: "flex",
      //   // justifyContent: "center",
      //   // alignItems: "flex-end",
      //   flexFlow: "column",
      // }}
    >
      <MobileAppBar/>
      {/* <Box
        sx={{
          display: "flex",
          justifyContent: "right",
          marginBottom: "10vh",
        }}
        >

        <img src="images/GameLogo.png"
          style={{
            width: "800px",
            minWidth: "300px",
            minHeight: "300px",
          }}
        >
        </img>
      </Box> */}
      <div className="main-section-content reveal">
        <img src="images/StudioLogoLarge.png"/>
        <div className="main-title">Angel Games Studio</div>
        <div className="main-noraml-Text">We are an indie games studio that works to give players the best experience.
              We are working on "Sorry, Wrong Door". Its an action-packed survival horror game with a comical twist
        </div>
        <div className='reveal reveal2'>
          <Button 
            variant="contained"
            href="https://store.steampowered.com/app/2133810/Sorry_wrong_door/"
            target="_blank"
            sx={{
              backgroundColor: "#bf1916",
              // marginBottom: 15,
              width: 220,
              height: 50,
              margin: "20px 0px",
              fontFamily: "sans-serif,Georgia,Time",
              // textTransform:"none",
              "&.MuiButtonBase-root:hover": {
                bgcolor: "#900c0a",
                // color: "black",
              },
            }}
          >
            View Game
          </Button>

        </div>
      </div>
      <div className="overlay"></div>
      <div className="video-container">
      <video src={video} autoPlay loop muted id="my-video">
      </video>
      </div>
      {/* <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-end",
          marginTop: "30vh",

        }}      
      >
      </Box> */}
    </div>
  );
};

export default MainSection;
